import { MenuItem, Stack, TextField } from '@mui/material';
import { phoneCountryOptions, sanitizeLocalPhoneNumber } from '../../lib/phone';

function PhoneNumberFields({ form, minLocalLength = 0, onChange }) {
  const hasPhoneLengthError =
    minLocalLength > 0 &&
    form.phoneLocalNumber.length > 0 &&
    form.phoneLocalNumber.length < minLocalLength;

  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
      <TextField
        label="Country"
        onChange={(event) => onChange({ ...form, countryCode: event.target.value })}
        select
        sx={{ width: { xs: '100%', sm: 180 }, flexShrink: 0 }}
        value={form.countryCode}
      >
        {phoneCountryOptions.map((option) => (
          <MenuItem key={`${option.code}-${option.label}`} value={option.dialCode}>
            {option.label} ({option.dialCode})
          </MenuItem>
        ))}
      </TextField>
      <TextField
        error={hasPhoneLengthError}
        fullWidth
        helperText={hasPhoneLengthError ? `Phone number must be at least ${minLocalLength} digits.` : ' '}
        inputMode="tel"
        label="Phone number"
        onChange={(event) =>
          onChange({
            ...form,
            phoneLocalNumber: sanitizeLocalPhoneNumber(event.target.value),
          })
        }
        placeholder="11481122333"
        value={form.phoneLocalNumber}
      />
    </Stack>
  );
}

export default PhoneNumberFields;
